import React from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";

import { Line } from "react-lineto";

import ImageResultContainer from "./image-result.container";

import {
  selectCurrentPage,
  selectLines,
  selectCurrentPageIndex,
  selectNumberOfPages,
  selectHasExtractions
} from "../../store/selector";

import Pagination from "../pagination";
import { setCurrentPageIndex } from "../../store/action";
import Tabs from "../tabs";

const Flex = styled.div`
  opacity: ${(props) => (props.visible ? "1" : "0")};
  display: flex;
  flex-direction: column;
  max-width: 1024px;
  transition: all 2s ease-in-out;

  @media (min-width: 1024px) {
    flex-direction: row;
  }
`;

const PaginationContainer = styled.div`
  opacity: ${(props) => (props.visible ? "1" : "0")};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  transition: all 2s ease-in-out;
`;

const Document = () => {
  const dispatch = useDispatch();
  const currentPage = useSelector(selectCurrentPage);
  const hasExtractions = useSelector(selectHasExtractions);
  const lines = useSelector(selectLines);
  const currentPageIndex = useSelector(selectCurrentPageIndex);
  const numberOfPages = useSelector(selectNumberOfPages);

  const handlePaginationClick = (index) => {
    dispatch(setCurrentPageIndex(index));
  };

  return (
    <React.Fragment>
      {numberOfPages > 1 && (
        <PaginationContainer visible={currentPage && hasExtractions}>
          <Pagination
            count={numberOfPages}
            currentIndex={currentPageIndex}
            onClick={handlePaginationClick}
          />
        </PaginationContainer>
      )}

      <Flex visible={currentPage && hasExtractions}>
        {currentPage && hasExtractions && (
          <React.Fragment>
            <ImageResultContainer />
            <Tabs />
          </React.Fragment>
        )}
      </Flex>

      {lines.length > 0 &&
        lines.map((line) => (
          <Line
            x0={line.x1}
            x1={line.x2}
            y0={line.y1}
            y1={line.y2}
            borderColor="#183F5C"
            borderStyle="dashed"
            borderWidth={1}
          />
        ))}
    </React.Fragment>
  );
};

export default Document;
